import { render } from "./futures.vue?vue&type=template&id=2aa78892&scoped=true"
import script from "./futures.vue?vue&type=script&lang=js"
export * from "./futures.vue?vue&type=script&lang=js"

import "./futures.vue?vue&type=style&index=0&id=2aa78892&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa78892"]])

export default __exports__